import { Text, View } from "react-native";

import { formatSetCount } from "@heraion/shared";

import type { SimulationStyles } from "./simulationStyles";

// #355: what the simulator's parts share.

export const formatSets = formatSetCount;

/** A label and its number on one line; the number drops under it when the
 *  two do not fit (font scale, a long word). */
export function Pair({ styles, label, value }: { styles: SimulationStyles; label: string; value: string }) {
  return (
    <View style={styles.pair} accessible accessibilityLabel={`${label}: ${value}`}>
      <Text style={styles.pairLabel}>{label}</Text>
      <Text style={styles.pairValue}>{value}</Text>
    </View>
  );
}
